(function () {
  function run() {
    var match = window.location.pathname.match(/^(.*)\/collections\/all-products\/?$/);
    if (!match) return;

    var prefix = match[1] || '';
    function url(handle) { return prefix + '/collections/' + handle; }
    var isJa = (document.documentElement.lang || '').toLowerCase().indexOf('ja') === 0;
    var header = document.querySelector('[data-section-type="collection-template"] .collection-header');
    if (!header || document.getElementById('MrakAllProductsBrowse')) return;

    var nav = document.createElement('div');
    nav.id = 'MrakAllProductsBrowse';
    nav.className = 'page-width mrak-all-products-browse';
    nav.innerHTML =
      '<div class="mrak-all-products-browse__head"><span>FIND PRODUCTS</span></div>' +
      '<div class="mrak-all-products-browse__desktop">' +
        '<div class="mrak-all-products-browse__row">' +
          '<span class="mrak-all-products-browse__label">COLLECTION</span>' +
          '<div class="mrak-all-products-browse__links">' +
            '<a class="is-active" href="' + url('all-products') + '">All Products</a>' +
            '<a href="' + url('tableware') + '">Tableware</a>' +
            '<a href="' + url('houseware') + '">Houseware</a>' +
            '<a href="' + url('pre-order') + '">Pre-order</a>' +
          '</div>' +
        '</div>' +
        '<div class="mrak-all-products-browse__row">' +
          '<span class="mrak-all-products-browse__label">PRODUCT</span>' +
          '<div class="mrak-all-products-browse__links">' +
            '<a class="is-active" href="' + url('all-products') + '">All Products</a>' +
            '<a href="' + url('allo-cloth') + '">Allo Cloth</a>' +
            '<a href="' + url('round-table') + '">Round Tables</a>' +
            '<a href="' + url('baskets') + '">Baskets</a>' +
            '<a href="' + url('gundri-watergrass') + '">Gundri Watergrass</a>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="mrak-all-products-browse__mobile">' +
        '<div class="mrak-mobile-find-group">' +
          '<label for="MrakMobileCollection">' + (isJa ? 'コレクションから探す' : 'BY COLLECTION') + '</label>' +
          '<div class="mrak-mobile-select-wrap">' +
            '<select id="MrakMobileCollection" aria-label="' + (isJa ? 'コレクションから探す' : 'Find by collection') + '">' +
              '<option value="' + url('all-products') + '">' + (isJa ? 'すべての商品' : 'All Products') + '</option>' +
              '<option value="' + url('tableware') + '">Tableware</option>' +
              '<option value="' + url('houseware') + '">Houseware</option>' +
              '<option value="' + url('pre-order') + '">Pre-order</option>' +
            '</select>' +
            '<span class="mrak-mobile-select-chevron" aria-hidden="true">⌄</span>' +
          '</div>' +
        '</div>' +
        '<div class="mrak-mobile-find-group">' +
          '<label for="MrakMobileProduct">' + (isJa ? '商品カテゴリーから探す' : 'BY PRODUCT CATEGORY') + '</label>' +
          '<div class="mrak-mobile-select-wrap">' +
            '<select id="MrakMobileProduct" aria-label="' + (isJa ? '商品カテゴリーから探す' : 'Find by product category') + '">' +
              '<option value="' + url('all-products') + '">' + (isJa ? 'すべての商品' : 'All Products') + '</option>' +
              '<option value="' + url('allo-cloth') + '">Allo Cloth</option>' +
              '<option value="' + url('round-table') + '">Round Tables</option>' +
              '<option value="' + url('baskets') + '">Baskets</option>' +
              '<option value="' + url('gundri-watergrass') + '">Gundri Watergrass</option>' +
            '</select>' +
            '<span class="mrak-mobile-select-chevron" aria-hidden="true">⌄</span>' +
          '</div>' +
        '</div>' +
      '</div>';

    var toolbar = header.querySelector('.filters-toolbar-wrapper');
    if (toolbar) header.insertBefore(nav, toolbar);
    else header.appendChild(nav);

    var collectionSelect = document.getElementById('MrakMobileCollection');
    var productSelect = document.getElementById('MrakMobileProduct');
    [collectionSelect, productSelect].forEach(function (select) {
      if (!select) return;
      select.addEventListener('change', function () {
        if (this.value) window.location.href = this.value;
      });
    });

    var filterTags = document.getElementById('FilterTags');
    if (filterTags) {
      var filterChild = filterTags.closest('.filters-toolbar__item-child');
      if (filterChild) filterChild.classList.add('mrak-mobile-native-filter');
    }
    var sortBy = document.getElementById('SortBy');
    if (sortBy) {
      var sortChild = sortBy.closest('.filters-toolbar__item-child');
      if (sortChild) sortChild.classList.add('mrak-mobile-sort');
    }

    var style = document.createElement('style');
    style.id = 'MrakAllProductsBrowseStyles';
    style.textContent = '\
      #MrakAllProductsBrowse { margin-top:18px; padding-top:24px; padding-bottom:24px; border-top:1px solid rgba(0,0,0,.18); border-bottom:1px solid rgba(0,0,0,.18); }\
      .mrak-all-products-browse__head { margin-bottom:14px; font-size:.78em; letter-spacing:.08em; }\
      .mrak-all-products-browse__row { display:grid; grid-template-columns:110px 1fr; gap:18px; padding:8px 0; }\
      .mrak-all-products-browse__label { font-size:.68em; letter-spacing:.09em; opacity:.62; }\
      .mrak-all-products-browse__links { display:flex; flex-wrap:wrap; gap:8px 18px; }\
      .mrak-all-products-browse__links a { color:inherit; text-decoration:none; font-size:.78em; line-height:1.5; border-bottom:1px solid rgba(0,0,0,.28); }\
      .mrak-all-products-browse__links a.is-active { border-bottom-color:currentColor; }\
      .mrak-all-products-browse__mobile { display:none; }\
      @media screen and (max-width:749px) {\
        #MrakAllProductsBrowse { margin-top:12px; padding-top:20px; padding-bottom:20px; }\
        .mrak-all-products-browse__head { margin-bottom:18px; }\
        .mrak-all-products-browse__desktop { display:none; }\
        .mrak-all-products-browse__mobile { display:block; }\
        .mrak-mobile-find-group + .mrak-mobile-find-group { margin-top:16px; }\
        .mrak-mobile-find-group label { display:block; margin-bottom:7px; font-size:.72em; letter-spacing:.04em; }\
        .mrak-mobile-select-wrap { position:relative; width:100%; }\
        .mrak-mobile-select-wrap select { display:block; width:100%; min-height:44px; margin:0; padding:10px 38px 10px 12px; border:1px solid rgba(0,0,0,.24); border-radius:0; background:#fff; color:inherit; font:inherit; font-size:.82em; line-height:1.3; -webkit-appearance:none; appearance:none; }\
        .mrak-mobile-select-chevron { position:absolute; right:13px; top:50%; transform:translateY(-54%); pointer-events:none; font-size:1em; }\
        .mrak-mobile-native-filter { display:none !important; }\
        .filters-toolbar__item-wrapper { display:block !important; width:100% !important; }\
        .mrak-mobile-sort { display:block !important; width:100% !important; margin:0 !important; }\
        .mrak-mobile-sort .filters-toolbar__label { display:block; margin-bottom:7px; }\
        .mrak-mobile-sort .filters-toolbar__input-wrapper { display:block; width:100% !important; max-width:none !important; }\
        .mrak-mobile-sort .filters-toolbar__input { width:100% !important; max-width:none !important; }\
        .filters-toolbar__item--count { margin-top:10px; width:100%; text-align:left; }\
      }';
    document.head.appendChild(style);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();